import { render, staticRenderFns } from "./ContractsStatistics.vue?vue&type=template&id=39b02f6e&"
import script from "./ContractsStatistics.vue?vue&type=script&lang=js&"
export * from "./ContractsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports